import { put, takeLatest, select, call } from "redux-saga/effects";
import { USER_PAGE_LOAD, userPageLoaded } from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import getSCUser from "../../../../../backend/oncall/administration/users/get-by-username";
import getPartnerUser from "../../../../../backend/oncall/partners/users/get-by-username";
import { showErrorPage } from "sc/actions/ui/location";

const userPageLoadSaga = function*(action) {
  try {
    if (action.payload.username === undefined) {
      // These are the default values on the add page.
      yield put(userPageLoaded({ username: "", enabled: true }));
      return;
    }
    const role = yield select(roleSelector);
    const getUser = role === ADMIN ? getSCUser : getPartnerUser;
    const result = yield call(getUser, action.payload.username);
    yield put(userPageLoaded({ username: action.payload.username, ...result }));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_PAGE_LOAD, userPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/edit-page-load.js